import { combineReducers } from 'redux';
import cartReducer from './cartReducer';

const rootReducer = combineReducers({
  counter: cartReducer,
});

export default rootReducer;
